import * as actionTypes from "../../constants/actionTypes";
import {
  getPhoneOperatingSystem,
  getPhoneOperatingSystemIds,
  getPhoneOperatingSystems
} from "../../api/phoneOperatingSystem";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidatePhoneOperatingSystems = () => {
  return {
    type: actionTypes.INVALIDATE_PHONE_OPERATING_SYSTEMS_DATA
  };
};

const loadPhoneOperatingSystem = (clientConfig, phoneOperatingSystemId) => {
  return {
    type: actionTypes.LOAD_PHONE_OPERATING_SYSTEM_DATA,
    promise: getPhoneOperatingSystem(clientConfig, phoneOperatingSystemId)
  };
};

const loadPhoneOperatingSystemPhoneOfferIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_OPERATING_SYSTEM_PHONE_OFFER_IDS_DATA,
    promise: getPhoneOperatingSystemIds(
      clientConfig,
      OFFER_TYPES.phoneOffer,
      dataStatus
    )
  };
};

const loadPhoneOperatingSystemPropositionIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_OPERATING_SYSTEM_PROPOSITION_IDS_DATA,
    promise: getPhoneOperatingSystemIds(
      clientConfig,
      OFFER_TYPES.proposition,
      dataStatus
    )
  };
};

const loadPhoneOperatingSystems = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_OPERATING_SYSTEMS_DATA,
    promise: getPhoneOperatingSystems(clientConfig, dataStatus)
  };
};

export {
  invalidatePhoneOperatingSystems,
  loadPhoneOperatingSystem,
  loadPhoneOperatingSystemPhoneOfferIds,
  loadPhoneOperatingSystemPropositionIds,
  loadPhoneOperatingSystems
};
